import { useState, useEffect } from "react";

const DeleteUserModal = ({
    show,
    onClose,
    onConfirm,
    isLoading,
    user,
}) => {
    const [closing, setClosing] = useState(false);

    const handleClose = () => {
        setClosing(true);
    };


    useEffect(() => {
        if (closing) {
            const timer = setTimeout(() => {
                setClosing(false);
                onClose();
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [closing, onClose]);

    if (!show && !closing) return null;

    return (
        <>
            <style>
                {`
          @keyframes slideDown {
            0% { transform: translateY(-20px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          @keyframes slideUp {
            0% { transform: translateY(0); opacity: 1; }
            100% { transform: translateY(-20px); opacity: 0; }
          }
          .slide-down { animation: slideDown 0.25s ease-out forwards; }
          .slide-up { animation: slideUp 0.25s ease-in forwards; }

          .modal-override {
            position: fixed;
            inset: 0;
            background-color: rgba(0,0,0,0.3);
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding-top: 5vh;
            z-index: 1050;
            pointer-events: auto;
          }
          .modal-dialog {
            position: relative;
            z-index: 1060;
            margin: 0 auto;
          }
          .custom-modal-content {
            position: relative;
            z-index: 1070;
            background: #fff;
            border-radius: 10px;
            padding: 20px 24px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15);
            pointer-events: auto;
          }
        .btn-cancel {
            background-color: #fff !important;
            color: var(--bs-primary) !important;
            border: 1px solid var(--bs-primary) !important;
            transition: all 0.3s ease !important;
          }

        .btn-cancel:hover {
            background-color: var(--bs-primary) !important;
            color: #fff !important;
        }
        
        .btn-delete {
            background-color: #dc3545 !important;
            color: #fff !important;
            border: 1px solid #dc3545 !important;
            transition: all 0.3s ease !important;
          }

          .btn-delete:hover {
            background-color: #b02a37 !important;
            color: #fff !important;
          }
          
          .user-card { background: #f8f9fa; border-radius: 8px; padding: 15px; }
          .avatar-circle { width:45px; height:45px; border-radius:50%; background:#e9ecef; display:flex; align-items:center; justify-content:center; font-weight:600; }
          .warning-title { color:#dc3545; font-weight:500; }
        `}
            </style>

            <div className="modal-override">
                <div className="modal-dialog" style={{ maxWidth: "800px" }}>
                    <div className={`custom-modal-content ${closing ? "slide-up" : "slide-down"}`}>

                        <h5 className="fw-semibold mb-4">Delete User</h5>
                        <hr />

                        <p className="fw-medium mb-3">Continue deleting this user?</p>



                        <div className="user-card d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-3">
                                <div className="avatar-circle">
                                    {user.name
                                        ?.split(" ")
                                        ?.map((n) => n[0])
                                        ?.join("")}
                                </div>
                                <div className="fw-semibold">{user.name}</div>
                            </div>

                            {/* <div className="text-end small">
                                <div>
                                    <span className="text-muted">User since</span><br />
                                    <strong>{user.userSince}</strong>
                                </div>
                                <div className="mt-2">
                                    <span className="text-muted">Added by</span><br />
                                    <strong>{user.addedBy}</strong>
                                </div>
                            </div> */}

                            {/* <div className="d-flex align-items-center gap-4 small">
                                <div>
                                    <span className="text-muted me-1">User since:</span>
                                    <strong>{user.userSince}</strong>
                                </div>

                                <div>
                                    <span className="text-muted me-1">Added by:</span>
                                    <strong>{user.addedBy}</strong>
                                </div>
                            </div> */}
                            <div className="d-flex align-items-start gap-5 small">

                                <div className="text-start">
                                    <div className="text-muted">User since</div>
                                    <div className="fw-semibold">{user.userSince}</div>
                                </div>

                                <div className="text-start">
                                    <div className="text-muted">Added by</div>
                                    <div className="fw-semibold">{user.addedBy}</div>
                                </div>

                            </div>
                        </div>


                        <div className="mb-3">
                            <p className="warning-title">⚠ This action is irreversible. Please read the following:</p>
                            <ul className="small text-muted ps-3">
                                <li>This action may impact integrations dependent on the user.</li>
                                <li>There may be loss of user-related data in apps that the user was a part of.</li>
                                <li>Deleting users will not reduce the number of licenses you pay for.</li>
                            </ul>
                        </div>

                        <div className="d-flex gap-3 mt-4">
                            <button className="btn btn-default" disabled={isLoading} onClick={onConfirm}>
                                {isLoading ? <div className="spinner-border spinner-border-sm" /> : "Initiate Deletion"}
                            </button>

                            <button className="btn btn-default-outline" disabled={isLoading} onClick={handleClose}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeleteUserModal;